// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"partnersPage_partnersContainer__XYZxR","header":"partnersPage_header__A6v8z","images":"partnersPage_images__L1gdP"};